
/* ══════════════════════════════════════════════
   RoseMuse — Shopify Theme JS
   ══════════════════════════════════════════════ */

/* ── POPUP ── */
function closePopup(){sessionStorage.setItem('rm_pop','1');var p=document.getElementById('popup');if(p)p.style.display='none';}
function submitPopup(){var e=document.getElementById('popupEmail');if(!e)return;var v=e.value.trim();if(!v||!v.includes('@'))return;sessionStorage.setItem('rm_pop','1');var p=document.getElementById('popup');if(p)p.style.display='none';}

/* ── MENU DRAWER ── */
function openMenu(){var d=document.getElementById('menuDrawer'),o=document.getElementById('menuOverlay');if(d)d.classList.add('open');if(o)o.classList.add('open');document.body.style.overflow='hidden';}
function closeMenu(){var d=document.getElementById('menuDrawer'),o=document.getElementById('menuOverlay');if(d)d.classList.remove('open');if(o)o.classList.remove('open');document.body.style.overflow='';}

/* ── CART STATE ── */
var cartItems=[];
var cartN=0;

function openCart(){
  renderCart();
  var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');
  if(d)d.classList.add('open');if(o)o.classList.add('open');
  document.body.style.overflow='hidden';
}
function closeCart(){
  var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');
  if(d)d.classList.remove('open');if(o)o.classList.remove('open');
  document.body.style.overflow='';
}

function addToCart(){
  var existing=cartItems.find(function(i){return i.id==='coffret';});
  if(existing){existing.qty++;}
  else{cartItems.push({id:'coffret',name:'Coffret Shrink-Less',price:129.00,qty:1,emoji:'\u{1F33A}'});}
  cartN=cartItems.reduce(function(s,i){return s+i.qty;},0);
  var badge=document.getElementById('cartCountBadge');
  if(badge){badge.textContent=cartN;badge.style.display='flex';badge.style.transform='scale(1.4)';setTimeout(function(){badge.style.transform='';},300);}
  openCart();
}

function changeQty(id,delta){
  var item=cartItems.find(function(i){return i.id===id;});
  if(!item)return;
  item.qty+=delta;
  if(item.qty<=0)cartItems=cartItems.filter(function(i){return i.id!==id;});
  cartN=cartItems.reduce(function(s,i){return s+i.qty;},0);
  var badge=document.getElementById('cartCountBadge');
  if(badge){if(cartN>0){badge.textContent=cartN;badge.style.display='flex';}else{badge.style.display='none';}}
  renderCart();
}

function renderCart(){
  var body=document.getElementById('cartBody');
  var footer=document.getElementById('cartFooter');
  if(!body||!footer)return;
  if(!cartItems.length){
    body.innerHTML='<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Votre panier est vide</div>';
    footer.style.display='none';
    return;
  }
  var html='';var total=0;
  cartItems.forEach(function(item){
    var sub=(item.price*item.qty).toFixed(2).replace('.',',');
    total+=item.price*item.qty;
    html+='<div class="cart-item"><div class="cart-item-img">'+item.emoji+'</div><div><div class="cart-item-name">'+item.name+'</div><div class="cart-item-price">'+sub+' \u20AC</div><div class="cart-item-qty"><button class="qty-btn" onclick="changeQty(\''+item.id+'\',-1)">\u2212</button><span class="qty-num">'+item.qty+'</span><button class="qty-btn" onclick="changeQty(\''+item.id+'\',1)">+</button></div></div><button class="cart-remove" onclick="changeQty(\''+item.id+'\',-'+item.qty+')">\u00D7</button></div>';
  });
  body.innerHTML=html;
  var ts=total.toFixed(2).replace('.',',')+' \u20AC';
  var ct=document.getElementById('cartTotal'),cb=document.getElementById('cartTotalBtn');
  if(ct)ct.textContent=ts;if(cb)cb.textContent=ts;
  footer.style.display='block';
}

/* ── SEARCH ── */
function openSearch(){var o=document.getElementById('searchOverlay');if(o)o.classList.add('open');setTimeout(function(){var i=document.getElementById('searchInput');if(i)i.focus();},100);}
function closeSearch(){var o=document.getElementById('searchOverlay');if(o)o.classList.remove('open');}

/* ── HERO SLIDER ── */
var cur=0;var TOTAL=3;
function slideTo(n){
  var track=document.getElementById('heroTrack');
  if(!track)return;
  cur=((n%TOTAL)+TOTAL)%TOTAL;
  track.style.transform='translateX(-'+cur*100+'%)';
  document.querySelectorAll('.hero-dot').forEach(function(d,i){d.classList.toggle('on',i===cur);});
}

/* ── PRODUCT GALLERY — opacity fade ── */
var galCur=0;
function galleryTo(n){
  galCur=n;
  document.querySelectorAll('.gallery-slide').forEach(function(s,i){s.classList.toggle('active',i===n);});
  document.querySelectorAll('.thumb').forEach(function(t,i){t.classList.toggle('active',i===n);});
}
function galleryNav(d){
  var total=document.querySelectorAll('.gallery-slide').length;
  if(!total)return;
  galCur=((galCur+d)%total+total)%total;
  galleryTo(galCur);
}

/* ── PRODUCT ACCORDIONS ── */
function toggleAccordion(btn){
  var item=btn.parentElement;
  var wasOpen=item.classList.contains('open');
  item.classList.toggle('open');
  var icon=btn.querySelector('.accordion-icon');
  if(icon)icon.textContent=wasOpen?'+':'\u2212';
}

/* ── NEWSLETTER ── */
function submitNl(){var el=document.getElementById('nlEmail');if(!el)return;var v=el.value.trim();if(!v||!v.includes('@'))return;var f=document.querySelector('.nl-form');if(f)f.innerHTML='<p style="color:var(--deep);font-weight:700;font-size:14px;padding:12px 0">\u{1F389} Merci ! V\u00E9rifiez votre bo\u00EEte mail.</p>';}

/* ── LANG ── */
function setLang(l,btn){
  document.querySelectorAll('.lang-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
}

/* ══ INIT — runs when DOM is ready ══ */
document.addEventListener('DOMContentLoaded', function(){

  /* Popup */
  setTimeout(function(){var p=document.getElementById('popup');if(p&&!sessionStorage.getItem('rm_pop'))p.style.display='flex';},4000);

  /* Escape key */
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeSearch();closeMenu();closeCart();}});

  /* Hero auto-slide */
  setInterval(function(){slideTo(cur+1);},5500);

  /* Coming Soon — auto-scroll + manual */
  var comGrid=document.querySelector('.coming-grid');
  if(comGrid){
    var comSpeed=1;
    var comPaused=false;
    var comTimer=null;
    function comAutoScroll(){
      if(comPaused)return;
      comGrid.scrollLeft+=comSpeed;
      if(comGrid.scrollLeft>=comGrid.scrollWidth-comGrid.clientWidth){
        comGrid.scrollLeft=0;
      }
    }
    comTimer=setInterval(comAutoScroll,30);
    comGrid.addEventListener('touchstart',function(){comPaused=true;});
    comGrid.addEventListener('touchend',function(){setTimeout(function(){comPaused=false;},2000);});
    comGrid.addEventListener('mouseenter',function(){comPaused=true;});
    comGrid.addEventListener('mouseleave',function(){setTimeout(function(){comPaused=false;},1000);});
  }

  /* Scroll Reveal — fade-in */
  var revEls=document.querySelectorAll('.rev');
  if(revEls.length){
    var ro=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          ro.unobserve(e.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -60px 0px'});
    revEls.forEach(function(el){ro.observe(el);});
  }

});
